import http from '@/util/http'
class LetterManagement {
  constructor(){
    this.PREFIX = "/share-foreign"
  }
  // 删除文件
  delMissManageFile(data){
    let url = this.PREFIX+"/missive/missiveManage/delMissManageFile"
    return http.post(url,data)
  }
  // 获取对应的文件
  getMissManageFileList(data){
    let url = this.PREFIX+"/missive/missiveManage/missManageFileList"
    return http.post(url,data)
  }
  // 上传
  uploadMissManageFiles(data){
    let url = this.PREFIX+"/missive/missiveManage/uploadMissManageFiles"
    return http.post(url,data)
  }
  // 获取本公司公函列表
  getMissiveList(data){
    let url = this.PREFIX+"/missive/missiveManage/getMissiveList"
    return http.post(url,data)
  }
  //获取当前登录人信息
  getUserInfo(data){
    let url = this.PREFIX+"/missive/missiveManage/getContactsMes"
    return http.post(url,data)
  }
  //获取公函号
  getNumber(data){
    let url = this.PREFIX+"/missive/missiveManage/getNumber"
    return http.post(url,data)
  }

  //保存公函
  saveMissive(data){
    let url = this.PREFIX+"/missive/missiveManage/saveMissive"
    return http.post(url,data)
  }


  /**
   *
   *
   * @param {*} data
   * 修改公函
   */
  updateMissive(data){
    let url = this.PREFIX+"/missive/missiveManage/updateMissive"
    return http.post(url,data)
  }


  /**
   *
   *
   * @param {String} missiveId
   * 删除公函
   */
  deleteMissive(data){
    let url = this.PREFIX+"/missive/missiveManage/deleteMissive"
    return http.post(url,data)
  }

  /**
   *
   *
   * @param {String} missiveId
   * 打印公函
   *
   */
  printMissive(data){
    let url = this.PREFIX+"/missive/missiveManage/getMissiveList"
    return http.get(url,data)
  }



  /**
   * @param {String} missiveId
   * 提交审批
   *
  */

  submitApproval(data){
    let url = this.PREFIX+"/missive/missiveManage/submitApproval"
    return http.post(url,data)
  }

  /**
   *
   * 审核
   */

  examineApproval(data){
    let url = this.PREFIX+"/missive/missiveManage/examineApproval"
    return http.post(url,data)
  }



  /**
   * 查看详情
   *
   */
  detail(data){
    let url = this.PREFIX+"/missive/missiveManage/detail"
    return http.post(url,data)
  }


}

export default LetterManagement;
